<div class="revision-list-page">
  <div class="page-header">
    <div class="header-text">
      <h2>Revisões</h2>
      <p>
        Veículos identificados pelos checklists. Clique em uma linha para abrir
        o relatório de revisão.
      </p>
    </div>
    <div class="header-actions">
      <nz-select
        class="status-filter"
        [(ngModel)]="statusFilter"
        (ngModelChange)="onStatusFilterChange()"
        nzPlaceHolder="Filtrar por status">
        <nz-option
          *ngFor="let option of statusFilterOptions"
          [nzLabel]="option.label"
          [nzValue]="option.value"></nz-option>
      </nz-select>
      <button nz-button nzType="default" (click)="clearFilters()">
        Limpar filtros
      </button>
      <button nz-button nzType="primary" (click)="exportToPdf()">
        <i nz-icon nzType="file-pdf"></i>
        Exportar PDF
      </button>
    </div>
  </div>

  <div class="table-card">
    <div class="table-scroll">
      <nz-table
        #revisionTable
        [nzData]="items"
        [nzLoading]="false"
        [nzFrontPagination]="false"
        [nzShowPagination]="false"
        nzSize="middle">
        <thead>
          <tr>
            <th>Placa</th>
            <th>Modelo</th>
            <th>KM atual</th>
            <th>Próxima revisão</th>
            <th>Faltam / Atraso</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let item of revisionTable.data"
            [class]="getRowClass(item)"
            (click)="openDetail(item)">
            <td>
              <span class="plate-badge">{{ item.chassis | uppercase }}</span>
            </td>
            <td>{{ item.product_name || '-' }}</td>
            <td>
              <span class="km-value">{{ item.current_km | number: '1.0-0' }} km</span>
            </td>
            <td>
              {{
                item.next_revision_km !== null
                  ? (item.next_revision_km | number: '1.0-0') + ' km'
                  : '—'
              }}
            </td>
            <td>
              <span [class]="getKmRemainingClass(item)">
                {{ getKmRemainingLabel(item) }}
              </span>
            </td>
            <td>
              <nz-tag [nzColor]="getStatusColor(item.revision_status)">
                {{ getStatusLabel(item.revision_status) }}
              </nz-tag>
            </td>
          </tr>
        </tbody>
        <ng-template nzNoResult>
          <nz-empty
            nzNotFoundContent="Nenhum veículo com checklist encontrado"
            nzNotFoundImage="simple"
            class="list-empty"></nz-empty>
        </ng-template>
      </nz-table>
    </div>
  </div>

  <div class="table-footer" *ngIf="total > 0">
    <nz-pagination
      #pager
      [nzPageIndex]="currentPage"
      [nzPageSize]="currentPageSize"
      (nzPageIndexChange)="onPageChange($event)"
      (nzPageSizeChange)="onPageSizeChange($event)"
      [nzTotal]="total"
      nzResponsive="true"
      nzShowSizeChanger></nz-pagination>
  </div>
</div>
